import React, { useEffect, useState, useRef } from "react";
import "./health.css";

const statsData = [
  { target: 750, label: "Treated Patients" },
  { target: 75, label: "Surgeries Done" },
  { target: 100, label: "Expert Panel" },
  { target: 100, label: "Awards" },
];

function StatsCounter() {
  const [counts, setCounts] = useState(statsData.map(() => 0));
  const statsRef = useRef(null);
  const observerRef = useRef(null);

  useEffect(() => {
    setCounts(statsData.map(() => 0));

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          startCounting();
        }
      },
      {
        threshold: 0.5,
      }
    );

    if (statsRef.current) {
      observer.observe(statsRef.current);
      observerRef.current = observer;
    }

    return () => {
      if (observerRef.current && statsRef.current) {
        observerRef.current.unobserve(statsRef.current);
      }
    };
  }, []);

  const startCounting = () => {
    let animationFrame;
    let start = Date.now();

    const duration = 2000;

    const animate = () => {
      const now = Date.now();
      const progress = Math.min((now - start) / duration, 1);

      setCounts(statsData.map((stat) => Math.floor(stat.target * progress)));

      if (progress < 1) {
        animationFrame = requestAnimationFrame(animate);
      }
    };

    animate();

    return () => cancelAnimationFrame(animationFrame);
  };

  return (
    <div className="health-stats">
      <h2
        style={{
          textAlign: "center",
          fontWeight: "bold",
          fontSize: "24px",
          marginBottom: "20px",
        }}
      >
        Data Driven Care You Can Trust
      </h2>
      <div className="dc-stats-bar" ref={statsRef}>
        {statsData.map((stat, index) => (
          <div key={index} className="dc-stat-box">
            <h2 className="dc-stat-value">
              {counts[index]}
              {/* {stat.target >= 75 ? "k+" : "+"}  */}
              {stat.label === "Expert Panel" || stat.label === "Awards" ? "+" : "k+"}

            </h2>
            <p className="dc-stat-label">{stat.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default StatsCounter;
